import axios from "axios";

const api = axios.create({
  baseURL: "https://api.davidjorgeadvogados.com.br/",
  //       baseURL: "http://192.168.0.116:3333/",
});

export default api;
